import type { RunStatus } from './runnerApiClient';

/**
 * Run status colours, shared by the dashboard lineup and the runs screen so a
 * status cannot be amber on one page and green on the other. Labels are NOT
 * here on purpose: the dashboard speaks inline English, the runs screen is
 * translated — one colour, two vocabularies.
 */
export const RUN_STATUS_STYLE: Record<RunStatus, { bg: string; fg: string }> = {
  open: { bg: '#eef2f6', fg: '#4b5563' },
  locked: { bg: '#eef2f6', fg: '#4b5563' },
  in_prep: { bg: '#fef3c7', fg: '#b45309' },
  pickup_in_progress: { bg: '#ffedd5', fg: '#c2410c' },
  out_for_delivery: { bg: '#dbeafe', fg: '#1d4ed8' },
  completed: { bg: '#dcfce7', fg: '#15803d' },
  settled: { bg: '#dcfce7', fg: '#15803d' },
  cancelled: { bg: '#fee2e2', fg: '#b91c1c' },
};

/** HH:MM (24h) -> locale time. Windows are wall-clock in the metro, so UTC
 *  is used purely to stop the browser's zone from shifting them. */
export function prettyTime(hhmm: string, locale: string): string {
  const [h, m] = hhmm.split(':').map(Number);
  return new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: '2-digit', timeZone: 'UTC' }).format(new Date(Date.UTC(1970, 0, 1, h, m)));
}

/** YYYY-MM-DD -> "Tue, Sep 8". */
export function prettyRunDate(ymd: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }).format(new Date(`${ymd}T00:00:00.000Z`));
}

/** ISO -> locale time of day, in the viewer's zone (these are real instants). */
export function prettyInstant(iso: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: '2-digit' }).format(new Date(iso));
}

/** YYYY-MM-DD for today ± n days, UTC-anchored to match the API's date math. */
export function ymdOffset(days: number): string {
  const d = new Date();
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}
